import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const deleteConfiguration = async (
  namespace: string,
  configurationId: string,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.delete(
      `${url}/api/v1/ns/${namespace}/configuration`,
      {
        headers,
        params: {
          configuration_id: configurationId,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to delete configuration. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while deleting configuration.",
      );
    }
  }
};
